export const useSearchQuery = (key: string) => {
    const url = new URL(window.location.href);
    const result = url.searchParams.get(key);
    return result;
}